module.exports = __webpack_public_path__ + "static/media/photo-icon.0da097bc.svg";